import { temAcesso } from '@/shared/auth/temAcesso'

const MensagensPainel = () => import('./MensagensPainel.vue')
const Mensagem = () => import('./Mensagem.vue')
const Conversa = () => import('./ConversaDetalhes.vue')
const NovaConversa = () => import('./NovaConversa.vue')

export default {
    path: 'mensagens',
    name: 'Mensagens',
    component: MensagensPainel,
    beforeEnter: (to, from, next) => {
        if (temAcesso('MENSAGENS-00')) {
            next()
        }
    },
    children: [
        {
            path: 'nova',
            name: 'Mensagens_Inserir',
            component: Mensagem,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        },
        {
            path: ':conversaId',
            name: 'Mensagens_Conversa',
            component: Conversa,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        },
        {
            path: ':mensagemId',
            name: 'Mensagens_Detalhar',
            component: Mensagem,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        },
        {
            path: 'novaConversa',
            name: 'Conversa_Inserir',
            component: NovaConversa,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        }
    ]
}
